module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2@2-0b8e882d3dacaecfb695c3af572a0c1d.webp";